import { render, staticRenderFns } from "./CustomInputColor.vue?vue&type=template&id=0e4f1547&"
import script from "./CustomInputColor.vue?vue&type=script&lang=js&"
export * from "./CustomInputColor.vue?vue&type=script&lang=js&"
import style0 from "./CustomInputColor.vue?vue&type=style&index=0&id=0e4f1547&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports